module.exports = __webpack_public_path__ + "img/line.c20a4474.png";